import Panel from "Components/Panel/Panel";
import React, { useEffect, useState } from "react";
import RightArrow from "../../../../../Components/SideBar/assets/icons/right-arrow.png"
import OptionsPanel from "Components/OptionsPanel/OptionsPanel";
import ExecuteAxios from "Components/ExecuteAxios/ExecuteAxios";
import RevenueCompanyList from "./RevenueCompanyList/RevenueCompanyList";

const RevenueDayPanel = ({
    costDayIdSelecteds,
    dsItem,
    dsMonth,
    showNewRevenueMonthPanel,
    onUpdateInsertRevenue,
    handleClose,
    getButtonToShowSubtitles,
    panelListCostDay,
    updatePanelCostSpreadsheet,
    onUpdatePanelCostSpreadsheet,
    onUpdateIdEmployee,
    onUpdateReloadSalaryBenefitsCost,
    itemInValidation
}) => {
    const [companyName, setCompanyName] = useState(null)
    const [updating, setUpdating] = useState(false)

    const costDayStyle = {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '95%',
        zIndex: '0',
        overflow: 'hidden'
    }

    useEffect(() => {
        const fetchData = async () => {
            const parameters = {
                id: costDayIdSelecteds[0]
            }
            const revenueProductionsList = await ExecuteAxios.api('get', '/supplier/get-description-supplier-by-id/', { params: parameters });
            if (revenueProductionsList) {
                setCompanyName(revenueProductionsList)
            }
        }
        if (!costDayIdSelecteds || costDayIdSelecteds.length != 1) {
            setCompanyName(null)
        } else {
            fetchData();
        }
    }, [costDayIdSelecteds])

    function getProductionsRevenuePanel() {
        if (costDayIdSelecteds && costDayIdSelecteds.length === 1) {
            return (
                {
                    label: companyName || 'Selecione um registro',
                    component: (
                        <RevenueCompanyList
                            costDayIdSelecteds={costDayIdSelecteds}
                            updating={updating}
                            showNewRevenueMonthPanel={showNewRevenueMonthPanel}
                            updatePanelCostSpreadsheet={updatePanelCostSpreadsheet}
                            onUpdateInsertRevenue={onUpdateInsertRevenue}
                            onUpdatePanelCostSpreadsheet={onUpdatePanelCostSpreadsheet}
                            onUpdating={setUpdating}
                            onUpdateReloadSalaryBenefitsCost={onUpdateReloadSalaryBenefitsCost}
                            itemInValidation={itemInValidation}
                        />
                    )
                }
            )
        } else {
            return (
                {
                    label: companyName || 'Selecione um registro',
                    component: (
                        null
                    )
                }
            )
        }
    }

    return (
        <Panel titlePage={dsMonth + ' - ' + dsItem}
            style={costDayStyle}
            canViewCRUD={true}
            componentRightButtons={(updating || showNewRevenueMonthPanel) ? null :
                <button
                    style={{
                        backgroundImage: `url(${RightArrow})`,
                        backgroundSize: '30px 30px',
                        width: '35px',
                        height: '35px',
                        backgroundRepeat: 'no-repeat',
                        backgroundColor: 'transparent',
                        border: 'none',
                        cursor: 'pointer',
                        alignItems: 'center'
                    }}
                    onClick={handleClose}
                />
            }
            subtitlesPanelBottom={getButtonToShowSubtitles()}
        >
            <OptionsPanel
                options={[
                    {
                        label: 'Faturamento',
                        component: panelListCostDay,
                    },
                    getProductionsRevenuePanel()
                ]}
                heigthLess={'60px'}
            />
        </Panel>
    )
}

export default RevenueDayPanel;